import React from 'react';
import { useUser } from '../context/UserContext';
import Tabs from '../components/UI/Tabs';
import ProductCreatePage from '../components/Products/ProductCreatePage';
import ProductsList from '../components/Products/ProductsList';

const ProductsManagementPage = () => {
    const { hasAnyPermission, hasPermission } = useUser();

    const canCreate = hasPermission("products", "create");
    const canManage = hasAnyPermission("products", ["edit", "delete", "view"]);

    const tabs = [];

    if (!canCreate && !canManage) {
        return <div className="text-center text-red-500 text-2xl font-bold">У вас нет доступа к этому модулю</div>;
    }

    if (canManage) {
        tabs.push({
            label: 'Список продуктов',
            content: <ProductsList />
        });
    }

    if (canCreate) {
        tabs.push({
            label: 'Создать продукт',
            content: <ProductCreatePage />
        });
    }

    return (
        <div className="p-6">
            <Tabs tabs={tabs} />
        </div>
    );
};

export default ProductsManagementPage; 